/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react";
import Document from "../../../../assets/img/document.png";
import {formatSQLDateShort} from "../../../../utils/formatSQLDate";
import PropTypes from "prop-types";
import {handleDownloadDevis} from "../_utils/handleDownloadDevis";
import useWindowDimensions from "../../../../hook/useWindowDimension";

const DevisList = ({documents}) => {

    const {width} = useWindowDimensions();
    const isDevis = documents.find((doc) => doc.type == 1 ? true : false);

    return (
        <div className="listElements">
            <div className="title">
                <span>Vos Devis</span>
            </div>
            {!isDevis && width < 599 &&
                <h4 className={"noDocument"}>Aucun devis disponible</h4>
            }
            <ul>
                {documents &&
                    documents.map((doc) => {
                        if (doc && doc.type == 1) {
                            return (
                                <li key={doc.id} onClick={() => handleDownloadDevis(doc.id)}>
                                    <img src={Document} alt="document"/>
                                    <div>
                                        <h1>Devis de {doc.namePrestataire}</h1>
                                        <h2>Numéro {doc.referenceExt}</h2>
                                        <h2 className="amount">Montant : {doc.amountDevis} €</h2>
                                        <h2>Ajouté le {formatSQLDateShort(doc.datePost)}</h2>
                                        {doc.state == 0 &&
                                            <h2>En attente d&apos;acceptation</h2>
                                        }
                                        {doc.state == 1 &&
                                            <h2>Devis accepté</h2>
                                        }
                                        {doc.state == 2 &&
                                            <h2>Devis refusé</h2>
                                        }
                                    </div>
                                </li>
                            );
                        }
                    })}

            </ul>
        </div>
    );
};

DevisList.propTypes = {
    documents: PropTypes.array,
};

export default DevisList;
